import 'BomdisoftComponents/store-badges/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { AppleGlyph, GooglePlayGlyph } from 'BomdisoftComponents/store-badges/glyphs';
import { listingFor, MOBILE_STORES, type MobileAppProduct, type MobileStore } from 'BomdisoftComponents/store-badges/listings';
import { STORE_NAMES, STORE_TEST_IDS } from 'BomdisoftComponents/store-badges/render';
import { badgeComingSoonOn, badgeComingSoonToThe, badgeDownloadOnThe, badgeGetItOn, type SupportedLanguage } from '@bomdisoft/translations';

export { STORE_NAMES, STORE_TEST_IDS } from 'BomdisoftComponents/store-badges/render';

export type StoreBadgesProps = {
  className?: string;
  language: SupportedLanguage;
  product: MobileAppProduct;
  testId?: string;
};

type StoreBadgeProps = {
  language: SupportedLanguage;
  store: MobileStore;
  testId: string;
  url: string | null;
};

const StoreBadge = ({ language, store, testId, url }: StoreBadgeProps) => {
  const glyph = store === 'appStore' ? <AppleGlyph /> : <GooglePlayGlyph />;
  const listed = store === 'appStore' ? badgeDownloadOnThe[language] : badgeGetItOn[language];
  const unlisted = store === 'appStore' ? badgeComingSoonToThe[language] : badgeComingSoonOn[language];
  const label = (
    <span className='bomdisoft-store-badges-label'>
      <span className='bomdisoft-store-badges-small'>{url === null ? unlisted : listed}</span>
      <span className='bomdisoft-store-badges-large'>{STORE_NAMES[store]}</span>
    </span>
  );

  if (url === null) {
    return (
      <span aria-disabled='true' className='bomdisoft-store-badges-badge' data-soon='' data-testid={testId}>
        {glyph}
        {label}
      </span>
    );
  }

  return (
    <a className='bomdisoft-store-badges-badge' data-testid={testId} href={url} rel='noopener noreferrer' target='_blank'>
      {glyph}
      {label}
    </a>
  );
};

export const StoreBadges = ({ className, language, product, testId = 'store-badge' }: StoreBadgesProps) => (
  <div className={joinClasses('bomdisoft-store-badges', className)} data-testid={testId}>
    {MOBILE_STORES.map(store => (
      <StoreBadge key={store} language={language} store={store} testId={`${testId}-${STORE_TEST_IDS[store]}`} url={listingFor(product, store)} />
    ))}
  </div>
);
